import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useFormContext } from "react-hook-form";
import { Form } from "semantic-ui-react";

// Actions
import ObservationsAction from "@common/redux/actions/ObservationsAction";

// Hooks and Helpers
import useObservationCustomerForm from "@common/components/helpers/Observations/useObservationCustomerForm";
import useObservationForm from "@common/components/helpers/Observations/useObservationForm";
import {
  getCurrentDateTime,
  setComplianceFormDateTime,
} from "../../helpers/datetime";

// Components
import StandardHiddenInputs from "@common/components/shared/forms/StandardHiddenInputs";
import FormButtonsComponent from "@common/components/shared/forms/FormButtonsComponent";
import DateAndTimeGroup from "@common/components/shared/forms/DateAndTimeGroup";
import Reminder from "../Reminder";
import ObservationsSelectForm from "./ObservationsSelectForm";
import TextareaComponent from "@common/components/shared/forms/TextareaComponent";
import CustomerForm from "@common/components/shared/CustomerForm";
import useLogin from "../../hooks/useLogin";
import AlertsAndSessions from "../AlertsAndSessions";

const ObservationsForm = () => {
  const { record, customerRecord, moodOptions } = useSelector((state) =>
    ObservationsAction.getStatePath(state),
  );

  const {
    control,
    register,
    handleSubmit,
    setValue,
    formState: { isValid, errors },
  } = useFormContext();

  const { onSubmit, resetForm } = useObservationForm({
    record,
    customerRecord,
    moodOptions,
  });

  const [{ isDesktop }] = useLogin();

  const {
    onSelect,
    handleExists,
    handleNewCustomer,
    handleEditCustomer,
    handleRemoveCustomer,
  } = useObservationCustomerForm();

  useEffect(() => {
    if (!isDesktop) {
      setComplianceFormDateTime(setValue, "Observations");
    }
  }, []);

  return (
    <Form className="form-padding" onSubmit={handleSubmit(onSubmit)}>
      <StandardHiddenInputs />
      <CustomerForm
        onSelect={onSelect}
        handleNewCustomer={handleNewCustomer}
        handleExists={handleExists}
        handleEditCustomer={handleEditCustomer}
        handleRemoveCustomer={handleRemoveCustomer}
        unknownNameLabel={"Customer unknown"}
      />
      <AlertsAndSessions />
      <DateAndTimeGroup
        dateName="observationDate"
        timeName="observationTime"
        control={control}
        dateFormat="YYYY-MM-DD"
        errorsDate={errors.observationDate}
        errorsTime={errors.observationTime}
        maxDate={getCurrentDateTime()}
      />
      <ObservationsSelectForm />
      <TextareaComponent
        name="comments"
        label="Comments"
        placeholder="Please enter comments..."
        register={register}
        error={errors.comments}
        labelAbove={true}
        rows={2}
        fieldStyle="py-1"
      />
      <Reminder />
      <FormButtonsComponent
        isValid={isValid}
        resetForm={() => resetForm(false)}
      />
    </Form>
  );
};

export default ObservationsForm;
